class CartCheckoutAcknowledgements extends HTMLElement {
  connectedCallback() {
    this.syncElements();
    this.addEventListener('change', this.handleChange);
    this.syncState();
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.handleChange);
  }

  handleChange = (event) => {
    if (!(event.target instanceof HTMLInputElement) || !event.target.matches('[data-cart-acknowledgement]')) return;

    this.syncElements();
    this.syncState();
  };

  syncElements() {
    this.checkboxes = Array.from(this.querySelectorAll('[data-cart-acknowledgement]'));
    this.checkoutButton = this.querySelector('[data-cart-checkout-button]');
    this.acceleratedButtons = this.querySelector('[data-accelerated-checkout-buttons]');
  }

  syncState() {
    const allChecked = this.checkboxes.length > 0 && this.checkboxes.every((checkbox) => checkbox.checked);

    if (this.checkoutButton) {
      this.checkoutButton.disabled = !allChecked;
    }

    if (this.acceleratedButtons) {
      this.acceleratedButtons.setAttribute('aria-disabled', allChecked ? 'false' : 'true');
    }
  }
}

if (!customElements.get('cart-checkout-acknowledgements')) {
  customElements.define('cart-checkout-acknowledgements', CartCheckoutAcknowledgements);
}
